import React from 'react'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import { ReactComponent as RotationIcon } from '../../icon/north_compass.svg'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import clsx from 'clsx'
import { observer } from 'mobx-react-lite'
import useMapStore from '../../stores/useMapStore'

type CustomStylesProps = {
    rotation: number
}

const useStyles = makeStyles<Theme, CustomStylesProps>({
    iconColor: {
        width: '24px',
        height: '24px',
        '&:hover path': {
            fill: '#318AF1',
        },
        '&:hover circle': {
            fill: '#318AF1',
        },
    },

    iconRotation: {
        '-webkit-transform': (props) => `rotate(${props.rotation}deg)`,
        '-moz-transform': (props) => `rotate(${props.rotation}deg)`,
        '-ms-transform': (props) => `rotate(${props.rotation}deg)`,
        '-o-transform': (props) => `rotate(${props.rotation}deg)`,
        transform: (props) => `rotate(${props.rotation}deg)`,
    },
})

type MapToolRotationProps = {
    onClickRotation: () => void
    refElementNavigationIcon?: React.RefObject<SVGSVGElement>
    refElementDivIcon?: React.RefObject<HTMLDivElement>
}
const MapToolRotation = (props: MapToolRotationProps) => {
    const { t } = useTranslation()
    const mapStore = useMapStore()

    const classes = useStyles({
        rotation: mapStore.mapRotation,
    })

    const onClickRotation = () => () => {
        props.onClickRotation()
    }

    return (
        <Paper sx={{ mb: '8px', boxShadow: 'none' }}>
            <Tooltip title={t('LABEL.MAP.TOOLS.ROTATION') ?? ''} placement="left">
                <IconButton
                    sx={{
                        p: '10px',
                        bgcolor: 'none',
                        borderRadius: '5px',
                        width: '100%',
                    }}
                    aria-label="directions"
                    onClick={onClickRotation()}
                >
                    <RotationIcon className={clsx(classes.iconColor, classes.iconRotation, 'icon-navigation-rotate')} />
                </IconButton>
            </Tooltip>
        </Paper>
    )
}

export default observer(MapToolRotation)
